module.exports = __webpack_public_path__ + "2284e60e378b2304e722fd86e917d9f3.svg";